import template from './sales-report.html';
import controller from './sales-report.controller';
import './sales-report.scss';

let SalesReportComponent = {
  bindings: {},
  template,
  controller
};

export default SalesReportComponent;



// WEBPACK FOOTER //
// ./src/app/pages/sales-report/sales-report.component.js